export default "__VITE_ASSET__l4ekHKou__"